import { Modal } from 'components/Modal';
import styles from './ModalApproveMarketplace.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { ReactComponent as IconDone } from './img/iconDone.svg';

export const ModalApproveMarketplace = ({
  open,
  setOpen,
  saveOrder,
}: {
  open: boolean;
  setOpen: (e: boolean) => void;
  saveOrder?: (e: boolean) => void;
}) => {
  const handleSaveOrder = () => {
    setOpen(false);
    saveOrder?.(false);
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className={styles.root}>
        <Title className={styles.root_title} title='Опубликовать для всех' />
        <p className={styles.root_message}>
          Заказ будет виден всем пользователям зарегистрированным на платформе.
          Продолжить?
        </p>
        <div className={styles.root_btn}>
          <Button
            onClick={() => setOpen(false)}
            theme='outline'
            className={styles.root_btn_cancel}
            size='L'>
            <IconCancel />
          </Button>
          <Button
            onClick={handleSaveOrder}
            className={styles.root_btn_exit}
            theme='filed'
            size='L'>
            <div>
              Продолжить
              <IconDone />
            </div>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
